<template>
  <Contents />
</template>

<script>
import Contents from "@/gapp-components/components/common/content/Contents.vue";

export default {
  name: "ContentsPage",
  components: {
    Contents
  },
  metaInfo: {
    title: "Contents"
  },
  mounted() {
    this.$store.dispatch("setBreadcrumb", [
      {
        text: this.$i18n.translate("Dashboard"),
        to: { name: "dashboard" },
        exact: true
      },
      {
        text: "Admin"
      },
      {
        text: this.$i18n.translate("Contents")
      }
    ]);
  }
};
</script>
